export const globalAttributes = {
    agencyTypeGlobal: {
        POLICE: 203001,
        FIRE: 203002,
        EMS: 203003,
    },
    eventOriginGlobal: {
        NINE_ONE_ONE: 206001,
        NON_EMERGENCY_PHONE: 206002,
        SELF_INITIATED: 206003,
        CAD_ASSISTANCE: 206004,
    },
    boloLabelPriorityGlobal: {
        PRIORITY_1: 233315,
        PRIORITY_2: 233316,
        PRIORITY_3: 233317,
        PRIORITY_4: 233318,
    },
    locationCautionPriorityGlobal: {
        PRIORITY_1: 222000,
        PRIORITY_2: 222001,
        PRIORITY_3: 222002,
        PRIORITY_4: 222003,
    },
    cfsPriorityGlobal: {
        CFS_PRIORITY_1: 200001,
        CFS_PRIORITY_2: 200002,
        CFS_PRIORITY_3: 200003,
        CFS_PRIORITY_4: 200004,
        CFS_PRIORITY_5: 200005,
        CFS_PRIORITY_6: 200006,
        CFS_PRIORITY_7: 200007,
        CFS_PRIORITY_8: 200008,
        CFS_PRIORITY_9: 200009,
    },
    hospitalStatusGlobal: {
        OPEN: 233308,
        DIVERT: 233309,
        CONDITIONAL: 233310,
    },
    riskLevelGlobal: {
        RISK_1: 208001,
        RISK_2: 208002,
        RISK_3: 208003,
        RISK_4: 208004,
        RISK_5: 208005,
        RISK_6: 208006,
        RISK_7: 208007,
        RISK_8: 208008,
        RISK_9: 208009,
        RISK_10: 208010,
    },
    serviceRotationActionType: {
        ROTATE: 226001,
        REVERT: 226002,
        NO_ACTION: 226003,
    },
} as const;

export type AgencyTypeGlobalKeys = keyof typeof globalAttributes.agencyTypeGlobal;
export type AgencyTypeGlobal = typeof globalAttributes.agencyTypeGlobal[AgencyTypeGlobalKeys];

export function assertAgencyTypeGlobal(value: number | string): asserts value is AgencyTypeGlobal {
    if (typeof value === 'string') {
        value = Number(value);
    }

    if (
        value !== globalAttributes.agencyTypeGlobal.POLICE &&
        value !== globalAttributes.agencyTypeGlobal.FIRE &&
        value !== globalAttributes.agencyTypeGlobal.EMS
    )
        throw new Error('Invalid AgencyTypeGlobal');
}

type AgencyTypeIdToDisplay = Record<
    AgencyTypeGlobal,
    { uppercase: string; lowercase: string; capitalize: string }
>;
export const agencyTypeIdToDisplay: AgencyTypeIdToDisplay = {
    [globalAttributes.agencyTypeGlobal.POLICE]: {
        uppercase: 'POLICE',
        lowercase: 'police',
        capitalize: 'Police',
    },
    [globalAttributes.agencyTypeGlobal.FIRE]: {
        uppercase: 'FIRE',
        lowercase: 'fire',
        capitalize: 'Fire',
    },
    [globalAttributes.agencyTypeGlobal.EMS]: {
        uppercase: 'EMS',
        lowercase: 'ems',
        capitalize: 'EMS',
    },
};

export type ServiceRotationActionTypeGlobalKeys = keyof typeof globalAttributes.serviceRotationActionType;
export type ServiceRotationActionTypeGlobal = typeof globalAttributes.serviceRotationActionType[ServiceRotationActionTypeGlobalKeys];
type ServiceRotationActionTypeToDisplay = Record<ServiceRotationActionTypeGlobal, string>;

export const serviceRotationActionTypeToDisplay: ServiceRotationActionTypeToDisplay = {
    [globalAttributes.serviceRotationActionType.ROTATE]: 'Rotate',
    [globalAttributes.serviceRotationActionType.REVERT]: 'Revert',
    [globalAttributes.serviceRotationActionType.NO_ACTION]: 'No Action',
};
